import ProfessionalMapDiscovery from "@/pages/ProfessionalMapDiscovery";

// The Owner checks exactly the same discovery presentation as a visitor.
// Only the data source is different, and that source authorizes Owner server-side.
export default function ProfessionalMapOwnerQa() {
  return <ProfessionalMapDiscovery ownerPreview />;
}
